export const getActualTitle = (attribute) => {
  let result;

  attribute.values.map((item) => {
    const isAsset = attribute.type === 'Asset';
    const value = isAsset ? item.assetId : item.value;
    const actualValue = isAsset ? attribute.value.assetId : attribute.value;
    if (actualValue === value) {
      result = item.label;
    }
  });

  return result;
};

export const getActualPrice = ({ isAsset, item, priceInfo }) => {
  let price = 0;
  let label = item.label;
  if (isAsset && label !== 'None') {
    // const id = item.metadata._id;
    // const attributeInfo = useStoreSelector(getActualPriceById(id));
    price = priceInfo?.price ?? 0;
    console.log(`[getActualPrice] ${label}: priceInfo=`, priceInfo, `price=${price}`);
  } else {
    price = 0;
  }

  return price;
};

export const getProductParameters = ({
  item,
  attribute,
  setAttribute,
  hintPosition,
  name,
  NotImage = '',
  priceInfo = {},
}) => {
  const isAsset = attribute.type === 'Asset';
  let value = isAsset ? item.assetId : item.value;
  let actualValue;
  let isUrlLoaderActive;
  let price = getActualPrice({ isAsset, item, priceInfo });
  let testId = 99;

  if (attribute.value.query) {
    actualValue = attribute.value.query.metadata.option;
    isUrlLoaderActive = true;
  } else {
    actualValue = isAsset ? attribute.value.assetId : attribute.value;
    isUrlLoaderActive = false;
  }

  return {
    item,
    attribute,
    setAttribute,
    currentValue: actualValue,
    isAsset: isAsset,
    value: value,
    isUrlLoaderActive,
    hintPosition,
    NotImage,
    name,
    price,
  };
};
